import getConfig from "next/config";
import { STORYBLOK_BASE_URL } from "../config/api_collection";
import { StoryblokConfig } from "../config/storyblok";
import { get } from "../helper/api";
import IResource from "../model/resource";

/**
 * Gets resource list
 * @param publication
 * @returns
 */

const GET_STORYBLOK_CURRENT_VERSION = `${STORYBLOK_BASE_URL}/v1/cdn/spaces/me?token=${StoryblokConfig.accessToken}`;
const STORYBLOK_DS = `${STORYBLOK_BASE_URL}/v2/cdn/datasource_entries`;

export async function getDataSource(datasource, dimension = "") {
  const data: any = await fetchData(datasource, dimension)
    .then((data) => {
      const dsData: any = data?.datasource_entries;
      return dsData;
    })
    .catch((e) => ({
      code: 500,
      message: "Something went wrong..",
      details: e
    }));
  return data;
}
export async function getCurrentVersion() {
  const data: any = await fetchVersion()
    .then((data) => {
      const version: any = data;
      return version;
    })
    .catch((e) => ({
      code: 500,
      message: "Something went wrong..",
      details: e
    }));
  return data;
}
/**
 * Get resouce key and values from cms
 * @param publication
 * @returns
 */
export async function fetchData(datasource, dimension) {
  try {
    // const cv = Date.now();
    const resourceApi = `${STORYBLOK_DS}?dimension=${dimension}&datasource=${datasource}&token=${StoryblokConfig.accessToken}`;
    const data = get<IResource>(resourceApi)
      .then((data) => data)
      .catch((e) => null);
    return await data;
  } catch (e) {
    return {
      code: 500,
      message: "Something went wrong..",
      details: e
    };
  }
}

export async function fetchVersion() {
  try {
    const resourceApi = GET_STORYBLOK_CURRENT_VERSION;
    const data = get<IResource>(resourceApi)
      .then((data) => data)
      .catch((e) => null);
    return await data;
  } catch (e) {
    return {
      code: 500,
      message: "Something went wrong..",
      details: e
    };
  }
}
